import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-44bb856c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-list"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "common"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "新闻中心")])], -1));
const _hoisted_3 = {
  class: "main"
};
const _hoisted_4 = {
  class: "common"
};
const _hoisted_5 = {
  class: "operation-top"
};
const _hoisted_6 = {
  class: "list-wrap"
};
const _hoisted_7 = {
  class: "list"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "center"
};
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  class: "text"
};
const _hoisted_12 = {
  class: "time"
};
const _hoisted_13 = {
  class: "operation-checkbox"
};
const _hoisted_14 = {
  class: "operation-list1"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "dialog-footer"
};
import { ref, reactive, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';
import api from '@/api/api';
import router from '@/router';
export default /*#__PURE__*/_defineComponent({
  __name: 'news-console',
  setup(__props) {
    const selectId = ref('');
    const checkList = ref([]);
    let form = reactive({
      img: '',
      title: '',
      desc: '',
      time: ''
    });
    const uploadImg = ref('');
    const tab = ref('first');
    const page = reactive({
      pageNum: 1,
      pageSize: 5,
      total: 0
    });
    const dialogShow = ref(false);
    const loading = ref(false);
    const tabClick = tab => {};
    const handleSizeChange = size => {
      updateNewsList();
    };
    const handleCurrentChange = num => {
      updateNewsList();
    };
    const news = ref([]);
    const handleClose = done => {
      dialogShow.value = false;
    };
    // 重置form
    const resetForm = () => {
      uploadImg.value = '';
      form = reactive({
        img: '',
        title: '',
        desc: '',
        time: ''
      });
    };
    // 更新列表
    const updateNewsList = async () => {
      const res = await getNews({
        page: page.pageNum,
        limit: page.pageSize
      });
      // console.log(res)
      news.value = res.records;
      page.total = res.total;
      page.pageSize = res.size;
      page.pageNum = res.current;
    };
    // 获取新闻列表
    const getNews = async data => {
      const res = await api.getNews(data).then(data => data.data);
      return res;
    };
    // 发布新闻列表
    const clickDeployBtn = () => {
      ElMessageBox.confirm('确定要发布到线上吗？', {
        type: 'warning'
      }).then(async () => {});
    };
    // 添加新闻
    const clickAddBtn = () => {
      resetForm();
      dialogShow.value = true;
    };
    // 编辑新闻
    const clickEditBtn = item => {
      resetForm();
      selectId.value = item.id;
      uploadImg.value = item.images;
      form.img = item.images;
      form.title = item.title;
      form.desc = item.abstractText;
      form.time = item.publishTime;
      dialogShow.value = true;
    };
    // 保存新闻
    const clickSaveBtn = async id => {
      const params = {
        title: form.title,
        abstractText: form.desc,
        images: form.img,
        // publishTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        publishTime: form.time
      };
      if (id) {
        params.id = id;
      }
      const res = await api.addOrUpdateNews(params);
      if (res.code === 0) {
        ElMessage.success('保存成功');
        dialogShow.value = false;
        updateNewsList();
      } else {
        ElMessage.error(`保存失败：${res.msg}`);
      }
    };
    // 删除新闻
    const clickDeleteBtn = async ids => {
      ElMessageBox.confirm('确定要删除该条新闻吗？', {
        type: 'warning'
      }).then(async () => {
        const res = await api.deleteNews({
          ids
        });
        if (res.code === 0) {
          ElMessage.success('删除成功');
          updateNewsList();
        } else {
          ElMessage.error(`删除失败：${res.msg}`);
        }
      });
    };
    // 批量删除新闻
    const clickBatchDeleteBtn = async () => {
      const ids = checkList.value.join(',');
      if (ids && ids.length > 0) {
        ElMessageBox.confirm('确定要删除这些新闻吗？', {
          type: 'warning'
        }).then(async () => {
          const res = await api.deleteNews({
            ids
          });
          if (res.code === 0) {
            ElMessage.success('批量删除成功');
            updateNewsList();
          } else {
            ElMessage.error(`删除失败：${res.msg}`);
          }
        });
      } else {
        ElMessage.success('请选择新闻');
      }
    };
    const clickNewsItem = item => {
      router.push({
        name: 'news-detail-tiny',
        query: {
          id: item.id
        }
      });
    };
    const handleAvatarSuccess = (response, uploadFile) => {
      uploadImg.value = URL.createObjectURL(uploadFile.raw);
      form.img = response.data;
    };
    const beforeAvatarUpload = rawFile => {
      if (rawFile.type !== 'image/jpeg') {
        // ElMessage.error('Avatar picture must be JPG format!')
        // return false
      } else if (rawFile.size / 1024 / 1024 > 2) {
        ElMessage.error('图片大小不能超过 2MB');
        return false;
      }
      return true;
    };
    onMounted(async () => {
      updateNewsList();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tabs, {
        class: "tabs",
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => tab.value = $event),
        onTabClick: tabClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "新闻动态",
          name: "first"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
            class: "deploy-btn",
            onClick: clickDeployBtn
          }, {
            default: _withCtx(() => [_createTextVNode("发布到线上")]),
            _: 1
          }), _createVNode(_component_el_button, {
            class: "batch-delete-btn",
            onClick: clickBatchDeleteBtn
          }, {
            default: _withCtx(() => [_createTextVNode("批量删除")]),
            _: 1
          }), _createVNode(_component_el_button, {
            class: "add-btn",
            onClick: clickAddBtn
          }, {
            default: _withCtx(() => [_createTextVNode("新增")]),
            _: 1
          })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.value, (item, index) => {
            return _openBlock(), _createElementBlock("li", {
              key: index,
              class: "item",
              onClick: $event => clickNewsItem(item)
            }, [_createElementVNode("b", {
              class: "img bak",
              style: _normalizeStyle(`background-image: url('${item.images}')`)
            }, null, 4), _createElementVNode("div", _hoisted_9, [_createElementVNode("h3", _hoisted_10, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_11, _toDisplayString(item.abstractText), 1)]), _createElementVNode("span", _hoisted_12, _toDisplayString(item.publishTime), 1)], 8, _hoisted_8);
          }), 128))]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_checkbox_group, {
            class: "checkboxgroup",
            modelValue: checkList.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => checkList.value = $event)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.value, (item, index) => {
              return _openBlock(), _createBlock(_component_el_checkbox, {
                class: "checkbox",
                key: index,
                label: item.id
              }, null, 8, ["label"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.value, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "operation-item1"
            }, [_createVNode(_component_el_button, {
              onClick: $event => clickEditBtn(item)
            }, {
              default: _withCtx(() => [_createTextVNode("编辑")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              onClick: $event => clickDeleteBtn(item.id)
            }, {
              default: _withCtx(() => [_createTextVNode("删除")]),
              _: 2
            }, 1032, ["onClick"])]);
          }), 128))])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_pagination, {
        class: "pagination",
        "current-page": page.pageNum,
        "onUpdate:current-page": _cache[2] || (_cache[2] = $event => page.pageNum = $event),
        "page-size": page.pageSize,
        "onUpdate:page-size": _cache[3] || (_cache[3] = $event => page.pageSize = $event),
        "page-sizes": [5, 10, 20, 30],
        small: false,
        disabled: false,
        layout: "total, sizes, prev, pager, next, jumper",
        total: page.total,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total"])])])]), _createVNode(_component_el_dialog, {
        modelValue: dialogShow.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => dialogShow.value = $event),
        title: "新增",
        width: "30%",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_16, [_createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = $event => dialogShow.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[8] || (_cache[8] = $event => clickSaveBtn(selectId.value))
        }, {
          default: _withCtx(() => [_createTextVNode(" 保存 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(form),
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "图片"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              class: "avatar-uploader",
              action: "http://192.168.100.203:9000/apis/api-bigscreen/website/news/upload",
              "show-file-list": false,
              "on-success": handleAvatarSuccess,
              "before-upload": beforeAvatarUpload
            }, {
              default: _withCtx(() => [uploadImg.value ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: uploadImg.value,
                class: "avatar"
              }, null, 8, _hoisted_15)) : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "avatar-uploader-icon"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              }))]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "标题"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).title,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).title = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "摘要"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).desc,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).desc = $event),
              type: "textarea",
              rows: 5
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "时间"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(form).time,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).time = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});